import axios from 'axios';

axios.defaults.baseURL = process.env.REACT_APP_BACKEND;

export default axios;



// WEBPACK FOOTER //
// ./src/request.js